<template>
  <div class="servicebox">
    <section id="banner">
      <div class="wrapper" :style="{background: 'url(' + categoryInfo.categoryPic + ') no-repeat center center'}"></div>
    </section>
    <section id="breadcrumb" style="position: static; top: 0px;">
      <div class="wrapper">
        <img src="../assets/breadcrumb.png" />
        <router-link :to="{path: '/'}">回首页</router-link>&nbsp;&gt;&nbsp;客户服务&nbsp;
      </div>
    </section>
    <section id="content">
      <div class="wrapper">
        <h1 class="title">
          <span id="uiTag_Corporation" langargument="Common,Tag,284">客户服务</span>
        </h1>
        <div id="uiLbl_desc" class="des" v-html="content.content">

          <!-- <div class="des">
            <p>
              <strong>
                客制化
                <br />
              </strong>我们的客户来自各种不同的产业背景，而且我们了解每位客户拥有非常独特的应用要求。因此，我们提供硬件与韧体的客制化服务，以确保能成功满足客户的应用需求。客户还可以额外选购更进一步的客制化服务，像是自定义 PCB 布线与设计、提升 SSD 连续读取的效能，或增加安全功能，如加密机制、数据防护验证和 AES。
            </p>
            <p>
              &nbsp;
              <br />
              <strong>
                测试
                <br />
              </strong>汇迪森是一家着重于生产可靠高质量产品的公司，确保所有产品在原型和生产阶段都经过彻底的测试。一般而言，我们会进行两种测试：标准测试与客制化测试。标准测试包括一般要求的质量控制测试，如高低温循环测试、振动测试、Power Cycling测试及烧机测试。汇迪森会针对不同容量的 SSD 执行不同等级的烧机测试，例如我们的 64GB SSD，会经过8小时的烧机测试。每当客户提出要求，我们也会根据应用要求和指定情况提供客制化测试。客制化测试范例包括恶劣环境测试、坠落测试、10,000 次Power Cycling测试以及热冲击(Thermal shock)测试。
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>MyInnodisk</strong>
              <br />MyInnodisk 是专门提供给客户、经销商和合作伙伴的管理平台，将所有重要的信息子系统 (订单、RMA、FAE) 整合至单一入口网页，并提供会员容易使用的管理功能。会员们亦可在此处下载各种数据，包括产品数据表(Datasheet)、产品变更通知 (PCN) 和产品停产 (EOL) 通知、测试报告以及技术白皮书等。此外，利用收件匣和传送功能，会员们可更轻松地与汇迪森的业务进行互动。
            </p>
            <p>
              MyInnodisk 平台是专为我们的客户、经销商和合作伙伴所建立。若您想要深入了解关于 MyInnodisk 的信息，请
              <a >与我们联络</a>。
            </p>
          </div> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
import { getCategoryInfo, getContentList } from "@/api/content";
export default {
  name: "",
  data() {
    return {
      msg: "这是我的",
      categoryId: this.$route.query.categoryId,
      categoryInfo: {},
      content: {}
    };
  },
  mounted() {
    this.getBanner();
    this.getContent();
  },
  methods: {
    getBanner() {
      // console.log(this.categoryId)
      getCategoryInfo(this.categoryId).then((res) => {
        if (res.code !== 200) return;
        this.categoryInfo = res.data;
        this.categoryInfo.categoryPic =
          process.env.BASE_API + "/web" + this.categoryInfo.categoryPic;
      });
    },
    getContent() {
      let params = {
        size: 1,
        current: 1,
        categoryId: this.categoryId,
      };
      getContentList(params).then((res) => {
        if (res.code !== 200) return;
        if (res.data.records && res.data.records.length > 0) {
          this.content = res.data.records[0];
        }
      });
    },
  },
};
</script>

<style scoped >
#banner .wrapper {
  position: relative;
  width: 100%;
  height: 240px;
  box-sizing: border-box;
  background: url(../assets/20170519-17414241.jpg) center top no-repeat;
  background-size: 100% auto;
}
#banner .wrapper {
  /* background-size: auto 100% !important; */
}
section .wrapper {
  width: 1280px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}
@media screen and (max-width: 760px) {
  section#banner .wrapper {
    height: 140px;
  }
}
@media screen and (max-width: 1300px) {
  #banner .wrapper {
    background-size: auto 100%!important;
  }
}

#breadcrumb {
  width: 100%;
  color: #fff;
  background: #c8c9cb;
}
@media screen and (max-width: 760px) {
   section#breadcrumb .wrapper {
    padding: 10px;
    font-size: 12px;
  }
}
#breadcrumb .wrapper {
  padding: 13px 40px;
  line-height: 16px;
  text-align: left;
  font-size: 14px;
  color: #333;
}
#breadcrumb .wrapper img {
  vertical-align: top;
  margin-right: 5px;
}
img {
  border: none;
  max-width: 100%;
  vertical-align: middle;
}
#breadcrumb .wrapper a {
  color: #333;
}
@media screen and (max-width: 1000px){
 section#content .wrapper {
    width: 100%;
    padding: 40px 20px;
}}
#content .wrapper {
    width: 960px;
    padding: 40px 0;
    text-align: left;
    box-sizing: border-box;
}
@media screen and (max-width: 1300px){
.servicebox section .wrapper {
    width: 100%;
}}

#content .wrapper .title {
    font-size: 24px;
    color: #146cbd;
    padding: 20px 0;
    border-bottom: 1px #ccc solid;
    margin-bottom: 40px;
    font-family: latoweb;
}
#content .wrapper .des {
    line-height: 32px;
    font-size: 18px;
    padding: 0 0 40px;
    font-family: latoweblight;
    color: #666;
}
#content .wrapper .des a {
    font-size: 18px;
    line-height: 26px;
    padding: 0;
    font-family: latowebbold;
    text-decoration: underline;
    color: #15262e;
}

</style>



// WEBPACK FOOTER //
// src/pages/service.vue